const computeCardActionButtonBaseClassName =
  "inline-flex h-7 max-w-[200px] min-w-0 shrink-0 items-center justify-center rounded border border-zinc-700 bg-zinc-800 px-2 text-sm text-secondary transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0b0b0b]";

const computeCardActionButtonEnabledClassName =
  "text-white hover:border-zinc-500 hover:bg-zinc-700";

const computeCardActionButtonDisabledClassName =
  "cursor-not-allowed opacity-50 disabled:cursor-not-allowed disabled:opacity-50";

export const getComputeCardActionButtonClassName = ({
  className,
  disabled = false,
}: {
  className?: string;
  disabled?: boolean;
}) =>
  [
    computeCardActionButtonBaseClassName,
    disabled ? undefined : computeCardActionButtonEnabledClassName,
    disabled ? computeCardActionButtonDisabledClassName : undefined,
    className,
  ]
    .filter(Boolean)
    .join(" ");
